import { getRequest } from "../utils/axios";

export const portfolioService = {
  getPortfolio,
};

function getPortfolio({ view = "traffic", days = 28 } = {}, onSuccess, onError) {
  const query = new URLSearchParams({ view, days: String(days) });
  return getRequest(`/api/v1/portfolio/?${query.toString()}`, onSuccess, onError);
}
